import { createAction, props } from '@ngrx/store';

export const resetPassword = createAction('[Users] Reset Password', props<{ userId: string }>());

export const resetPasswordSuccess = createAction('[Users] Reset Password Success');

export const resetPasswordFailure = createAction('[Users] Reset Password Failure', props<{ error: any }>());
